import Store  from '../../src/redux';
import { sendRequest,sendRequestTarde, sendRequestTardeManger } from './baseRequest';
import { getDomainName } from "../util/helper";

const getHeaders = () => {
    const user = Store?.getState()?.user;
    return {
        'X-FNOTRADER-SECRET': user?.loginSecret,
        'X-FNOTRADER-USERID': user?.userID
    };
}

export const loginUser = (data) => {
    const params = {
        email: data.email,
        password: data.password,
        gtoken:data.gtoken,
        src: getDomainName()
    };
    return sendRequest('post', 'user-login', params);
};

export const registerUser = (data) => {
    const params = {
        firstName: data.fname,
        lastName: data.lname,
        mobile: data.mobile,
        email: data.email,
        password: data.password,
        gtoken: data.gtoken,
        path: window.location.host,
        referralId: data.rc
    };
    return sendRequest('post', 'user', params);
};

export const verifyUser = (token) => {
    return sendRequest('post', 'verify-email', { token: token });
};

export const fogotPassword = (email) => {
    return sendRequest('post', 'password-reset-request', { email: email });
};

export const resetPassword = (data) => {
    const params = {
        resetToken: data.token,
        password: data.password
    };
    return sendRequest('post', 'password-reset', params);
};

export const logoutUser = (data) => {
    const params = {
        loginSecret: data.loginSecret,
        email: data.email
    };
    return sendRequest('post', 'user-logout', params);
};


export const getprofile = () => {
   
    return sendRequestTarde('get', 'user-profile',  {}, getHeaders());
};

export const getBrokers = (status) => {
   
    return sendRequestTarde('get', `brokers?status=${status}`,  {}, getHeaders());
};

export const loginStatusCheck = (fnotraderUserId, fnotraderSecret) => {
    return sendRequestTardeManger('get', `login-check`,  {}, {
        "X-Fnotrader-Secret": fnotraderSecret,
        "X-Fnotrader-Userid": fnotraderUserId
      });
}